import { __assign, __generator } from "tslib";
import { eventChannel, buffers } from 'redux-saga';
import { select, call, takeEvery, all, fork, take } from 'redux-saga/effects';
import isSSR from '../../utils/isSSR';
import biLogger from '../BiLogger.logger';
import { logPageView } from './actions';
import { getPublicSession } from '../../publicSession/selectors';
import { BiEventType } from '../constants';
import { getBiContextData } from './selectors';
import isFinite from 'lodash/isFinite';
import Perfume from 'perfume.js';
// helper for logging events from sagas
export function logBiEvent(data, isPageView) {
    var contextData;
    if (isPageView === void 0) { isPageView = false; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(isPageView ? getPublicSession : getBiContextData)];
            case 1:
                contextData = _a.sent();
                return [4 /*yield*/, call([biLogger, 'log'], contextData, data)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleLogPageView(_a) {
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (isSSR()) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(logBiEvent, __assign({ evid: BiEventType.PAGEVIEW }, payload), true)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function makeBiData(beat, metrics) {
    var _a;
    var data = {
        evid: BiEventType.PERF_METRICS,
        // project
        appinf: (_a = window['__APP_INFO__']) !== null && _a !== void 0 ? _a : 'unknown',
        beat: beat,
    };
    var metricMap = {
        firstPaint: 'p_fp',
        firstContentfulPaint: 'p_fcp',
        firstInputDelay: 'p_fid',
        largestContentfulPaint: 'p_lcp',
        fetchTime: 'nt_ft',
        workerTime: 'nt_wt',
        totalTime: 'nt_tt',
        downloadTime: 'nt_dt',
        timeToFirstByte: 'nt_ttfb',
        headerSize: 'nt_hs',
        dnsLookupTime: 'nt_dlt',
        downlink: 'ni_dl',
        effectiveType: 'ni_et',
        rtt: 'ni_rtt',
        saveData: 'ni_sd',
    };
    for (var _i = 0, metrics_1 = metrics; _i < metrics_1.length; _i++) {
        var metric = metrics_1[_i];
        if (metric.duration && metricMap[metric.type]) {
            data[metricMap[metric.type]] = Math.round(metric.duration);
            continue;
        }
        if (metric.data) {
            var keys = Object.keys(metric.data);
            if (keys.length > 0)
                for (var _b = 0, keys_1 = keys; _b < keys_1.length; _b++) {
                    var key = keys_1[_b];
                    if (isFinite(metric.data[key])) {
                        data[metricMap[key]] = Math.round(metric.data[key]);
                    }
                    else {
                        data[metricMap[key]] = metric.data[key];
                    }
                }
        }
    }
    return data;
}
function handlePerfLogging() {
    var perfumeChannel, metrics, log, metricName, duration, data, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (typeof window === 'undefined') {
                    return [2 /*return*/];
                }
                perfumeChannel = eventChannel(function (emitter) {
                    new Perfume({
                        logging: false,
                        dataConsumption: false,
                        networkInformation: true,
                        resourceTiming: false,
                        analyticsTracker: function (log) { return emitter(log); },
                    });
                    return function () { };
                }, buffers.expanding());
                metrics = [];
                _b.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 12];
                return [4 /*yield*/, take(perfumeChannel)];
            case 2:
                log = _b.sent();
                metricName = log.metricName, duration = log.duration, data = log.data;
                _a = metricName;
                switch (_a) {
                    case 'navigationTiming': return [3 /*break*/, 3];
                    case 'networkInformation': return [3 /*break*/, 4];
                    case 'firstPaint': return [3 /*break*/, 5];
                    case 'firstContentfulPaint': return [3 /*break*/, 6];
                }
                return [3 /*break*/, 8];
            case 3:
                metrics.push({
                    type: metricName,
                    data: data,
                });
                return [3 /*break*/, 11];
            case 4:
                metrics.push({
                    type: metricName,
                    data: data,
                });
                return [3 /*break*/, 11];
            case 5:
                metrics.push({
                    type: metricName,
                    duration: duration,
                });
                return [3 /*break*/, 11];
            case 6:
                metrics.push({
                    type: metricName,
                    duration: duration,
                });
                return [4 /*yield*/, call(logBiEvent, makeBiData('fcp', metrics))];
            case 7:
                _b.sent();
                return [3 /*break*/, 11];
            case 8:
                metrics.push({
                    type: metricName,
                    duration: duration,
                });
                if (!(metricName === 'largestContentfulPaint')) return [3 /*break*/, 10];
                return [4 /*yield*/, call(logBiEvent, makeBiData('lcp', metrics))];
            case 9:
                _b.sent();
                metrics = [];
                _b.label = 10;
            case 10: return [3 /*break*/, 11];
            case 11: return [3 /*break*/, 1];
            case 12: return [2 /*return*/];
        }
    });
}
export default function rootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fork(handlePerfLogging)];
            case 1:
                _a.sent();
                return [4 /*yield*/, all([takeEvery(logPageView, handleLogPageView)])];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map